module.exports = __webpack_public_path__ + "media/images/products/template/01/06-03be731cbb91bb93af0eeafc1ccbc2ff.jpg";